module.exports = __webpack_public_path__ + "static/img/newsDetailPic3.a711fa9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsDetailPic3.png
// module id = ePxV
// module chunks = 1